import { Button, Container, TextInput } from "@marketplace/ui";
import { useTranslation } from "react-i18next";

import { Lintasarta2024Logo } from "../lintasarta-2024-logo";
import { SearchIcon } from "./icons";

export const PreviewHeader = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "previewLayout"
  });

  return (
    <header className="fixed top-0 left-0 right-0 bg-brand-white w-full h-fit z-50">
      <Container className="hidden md:flex !px-[16px] !md:px-2 flex-col">
        <nav className="flex items-center justify-between">
          <ul className="flex list-none m-0 p-0">
            <li>
              <span className="py-[10px] px-4 text-fjord-grey-500 font-semibold text-p-l block cursor-default">
                {t("header.howItWorks")}
              </span>
            </li>
            <li>
              <span className="py-[10px] px-4 text-fjord-grey-500 font-semibold text-p-l block cursor-default">
                {t("header.aboutUs")}
              </span>
            </li>
            <li>
              <span className="py-[10px] px-4 text-fjord-grey-500 font-semibold text-p-l block cursor-default">
                {t("header.contactUs")}
              </span>
            </li>
          </ul>
          <div className="py-[10px] px-4 text-fjord-grey-500 font-semibold text-p-l">
            EN
          </div>
        </nav>
      </Container>

      <div className="border-solid border-x-0 border-y border-y-mischka-100 h-[98px]">
        <Container className="!px-4 !md:px-2 flex items-center justify-between gap-4 md:gap-12 h-full">
          <div className="flex items-center max-w-[96px] md:max-w-fit">
            <Lintasarta2024Logo />
          </div>

          <div className="flex-1">
            <TextInput
              id="search"
              placeholder={t("header.searchPlaceholder")}
              className="md:hidden"
              readOnly
              classNames={{
                input: "!h-[40px] !border !border-solid !border-fjord-grey-200"
              }}
              rightSection={<SearchIcon className="cursor-default" />}
              rightSectionProps={{
                style: { right: "7px" }
              }}
            />
            <TextInput
              id="search"
              placeholder={t("header.searchPlaceholder")}
              className="hidden md:block"
              readOnly
              classNames={{
                input: "!h-[40px] !border !border-solid !border-fjord-grey-200"
              }}
              rightSection={<SearchIcon className="cursor-default" />}
              rightSectionProps={{
                style: { right: "7px" }
              }}
            />
          </div>

          <div className="items-center gap-x-6 hidden md:flex">
            <div className="flex gap-x-4">
              <Button variant="secondary" className="w-[128px]">
                {t("header.login")}
              </Button>
              <Button variant="primary" className="w-[128px]">
                {t("header.signUp")}
              </Button>
            </div>
          </div>
        </Container>
      </div>
    </header>
  );
};
